import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ISnackItem } from '@shared/interfaces/various/ISnackItem';
import { SnackType } from '@shared/enums';

@Injectable({
    providedIn: 'root'
})
export class SnackService {
    private readonly translate = inject(TranslateService);

    public readonly newSnackItem = new BehaviorSubject<ISnackItem>(null);

    public openSnackBarSuccess(text: string, duration = 3000): void {
        this.newSnackItem.next({ text, duration, type: SnackType.Success, date: new Date() });
    }

    public openSnackBarError(text: string, action = 'OK', duration = 3000): void {
        this.newSnackItem.next({
            text: this.translate.instant(text),
            duration,
            type: SnackType.Error,
            date: new Date()
        });
    }
}
